<template>
  <div class="note-tile">
    <div class="note-tile-content">
      {{ note.content }}
    </div>
  </div>
</template>
  
  <script lang="ts">
  import { CustomerNote } from '@/@types/responses/customer_note/CustomerNote'
  import { defineComponent } from 'vue'
  export default defineComponent({
    name: 'CustomerNoteTile',
    props: {
      note: {
        type: CustomerNote,
        required: true
      }
    }
  })
  </script>
  
<style scoped lang="scss">
.note-tile {
  position: relative;
  background-color: $Color-fill-gray;
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 15px;
  display: flex;

  &:last-of-type {
    margin-bottom: 0;
  }

  > .note-tile-content {
    flex: 0 0 90%;
    width: 90%;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    color: $Color-font-high;
    white-space: pre-wrap;
  }
}
</style>